// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useSessionStore from '@/app/store/session';
// Components
import Dropdown from '@/common-utils/components/renders/dropdown/Dropdown';
import ModalTerminatePayluddSubscription from '../modals/ModalTerminatePayluddSubscription';
// Common
import ICONS from '@/common-utils/enums/icons';
import Permissions from '@/app/permissions/Permissions';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';
// Lang
import { nsPayluddSubscription } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.payluddSubscription
 * @param root0.setLaunchRefetch
 * @returns {JSX}
 */
function DropdownPayluddSubscriptionsActionsRow({ payluddSubscription, setLaunchRefetch }) {

    // Store
    const permissions = useSessionStore(s => s.session.permissions);

    // State
    const [showModalTerminatePayluddSubscription, setShowModalTerminatePayluddSubscription] = useState(false);

    return (
        <>
            <Dropdown
                dataCy='payludd-subscription-actions-dropdown-row'
                triggerValues={{ variant: 'ghostNoBorder', icon: ICONS.MORE }}
                actions={[
                    {
                        icon: ICONS.SUBSCRIPTION_TERMINATE,
                        entity: 'actions.row.terminate_payludd',
                        namespace: nsPayluddSubscription,
                        className: 'text-danger',
                        onClick: () => setShowModalTerminatePayluddSubscription(true),
                        visible: true,
                        disabled: !hasRequiredPermissions({
                            permissions,
                            requiredPermissions: [Permissions.SUBSCRIPTION_TERMINATE.name]
                        }),
                        tooltipForbidden: 'title.permissions.access_denied'
                    }
                ]}
            />
            {
                showModalTerminatePayluddSubscription &&
                <ModalTerminatePayluddSubscription
                    isOpen={showModalTerminatePayluddSubscription}
                    setIsOpen={setShowModalTerminatePayluddSubscription}
                    payluddSubscription={payluddSubscription}
                    setLaunchRefetch={setLaunchRefetch}
                />
            }
        </>
    );
}

DropdownPayluddSubscriptionsActionsRow.propTypes = {
    payluddSubscription: PropTypes.object.isRequired,
    setLaunchRefetch: PropTypes.func.isRequired
};

export default DropdownPayluddSubscriptionsActionsRow;
